import React, { useState } from 'react';

const ReorderableGallery = ({ images, baseUrl, onDelete, onReorder }) => {
  const [draggedItem, setDraggedItem] = useState(null);
  const [dragOverItem, setDragOverItem] = useState(null);

  const handleDragStart = (e, index) => {
    setDraggedItem(index);
    e.dataTransfer.effectAllowed = "move";
    // Add some opacity to the dragged item
    e.target.style.opacity = '0.5';
  };

  const handleDragEnd = (e) => {
    e.target.style.opacity = '1';
    setDraggedItem(null);
    setDragOverItem(null);
  };

  const handleDragOver = (e, index) => {
    e.preventDefault();
    if (draggedItem === index) return;
    setDragOverItem(index);
  };

  const handleDrop = (e, dropIndex) => {
    e.preventDefault();
    if (draggedItem === dropIndex) return;

    const newImages = [...images];
    const draggedImage = newImages[draggedItem];
    
    // Remove dragged item
    newImages.splice(draggedItem, 1);
    // Insert at new position
    newImages.splice(dropIndex, 0, draggedImage);

    onReorder(newImages);
    setDraggedItem(null);
    setDragOverItem(null);
  };

  return (
    <div className="row g-2">
      {images.map((image, index) => (
        <div 
          key={image.id} 
          className="col-6"
          draggable="true"
          onDragStart={(e) => handleDragStart(e, index)}
          onDragEnd={handleDragEnd}
          onDragOver={(e) => handleDragOver(e, index)}
          onDrop={(e) => handleDrop(e, index)}
        >
          <div 
            className={`position-relative border rounded ${
              dragOverItem === index ? 'border-primary' : ''
            }`}
            style={{ 
              transition: 'border-color 0.2s ease',
              cursor: 'grab'
            }}
          >
            <img
              src={baseUrl + (image.formats?.thumbnail?.url || image.url)}
              alt=""
              className="img-thumbnail"
              style={{ 
                width: '100%', 
                height: '120px', 
                objectFit: 'cover',
                pointerEvents: 'none' // Prevents image drag ghost
              }}
            />
            <button
              type="button"
              className="btn btn-danger btn-sm position-absolute top-0 end-0 m-1"
              onClick={() => onDelete(image.id)}
            >
              <i className="bi bi-trash"></i>
            </button>
            <div className="position-absolute bottom-0 start-0 m-1">
              <small className="badge bg-secondary">
                {index + 1} of {images.length}
              </small>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ReorderableGallery;